import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import DashboardHome from '../views/HomeView.vue' // The parent layout component
import GlobalContent from '../views/GlobalContent.vue' // The new component for the global router-view

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    components: {
      default: DashboardHome // This renders the parent layout (sidebar, navbar, etc.)
    },
    children: [
      {
        path: '',
        name: 'Global',
        components: {
          global: GlobalContent // This renders the content inside <router-view name="global">
        },
        children: [
          {
            path: '',
            name: 'DashboardItem',
            components: {
              dashboardItem: () => import('../components/TransactionsItem.vue')
            }
          },
          {
            path: 'wallet-deposit',
            name: 'WalletDeposit',
            components: {
              dashboardItem: () => import('../components/WalletItem.vue')
            }
          },
          {
            path: '/membership-fee',
            name: 'MembershipFee',
            components: {
              dashboardItem: () => import('../components/MembershipFees.vue')
            }
          }
        ]
      },
      {
        path: '/user-profile',
        name: 'UserProfile',
        components: {
          global: () => import('../views/UserProfile.vue')
        },
        children: [
          {
            path: '',
            name: 'UserProfileItem',
            components: {
              profile: () => import('../components/UserProfileItem.vue')
            }
          },
          {
            path: '/withdraw-transctions',
            name: 'WithdrawTransactions',
            components: {
              profile: () => import('../components/WithdrawTrarnsaction.vue')
            }
          },
          {
            path: '/requested-withdraw-transactions',
            name: 'RequestedWithdrawTransaction',
            components: {
              profile: () => import('../components/RequestedWithdrawTransaction.vue')
            }
          },
          {
            path: '/deposit-transactions',
            name: 'DepositTransactions',
            components: {
              profile: () => import('../components/DepositTransactions.vue')
            }
          },
          {
            path: '/network-address',
            name: 'NetworkAddress',
            components: {
              profile: () => import('../components/NetworkWalletAddress.vue')
            }
          },
          {
            path: '/investment-interest',
            name: 'InvestmentInterest',
            components: {
              profile: () => import('../components/InvestmentInterest.vue')
            }
          },
          {
            path: '/return-on-investment',
            name: 'ReturnOnInvestment',
            components: {
              profile: () => import('../components/ReturnOnInvestment.vue')
            }
          },
          {
            path: '/request-withdraw',
            name: 'RequestWithdraw',
            components: {
              profile: () => import('../components/RequestWithdraw.vue')
            }
          },
          {
            path: '/my-referral-users',
            name: 'MyReferral',
            components: {
              profile: () => import('../components/MyReferralUsers.vue')
            }
          },
          {
            path: '/notifications',
            name: 'Notifications',
            components: {
              profile: () => import('../views/NotificationsList.vue')
            }
          },
          {
            path: '/notifications/:id',
            name: 'SingleNotification',
            components: {
              profile: () => import('../views/SingleNotification.vue')
            }
          },
          {
            path: '/create-notification',
            name: 'CreateNotification',
            components: {
              profile: () => import('../views/CreateNotification.vue')
            }
          }
        ]
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        components: {
          global: () => import('../views/DashboardAdmin.vue')
        }
      },
      {
        path: '/wallet-deposit-admin',
        name: 'WalletDepositAdmin',
        components: {
          global: () => import('../views/AdminWalletManagement.vue')
        }
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/auth-sign-in',
    name: 'AuthSignIn',
    component: () => import('../views/AuthSignin.vue')
  },
  {
    path: '/auth-sign-up',
    name: 'AuthSignUp',
    component: () => import('../views/AuthSignup.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, from, next) => {
//   const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null
//   const token = localStorage.getItem('auth_token')

//   if (to.meta.requiresAuth) {
//     if (!user || !token) {
//       return next({ name: 'AuthSignIn' })
//     }

//     if (to.meta.role) {
//       if (user.role !== to.meta.role) {
//         if (user.role === 'admin') {
//           return next({ path: '/dashboard' })
//         } else if (user.role === 'user_client') {
//           return next({ path: '/' })
//         } else {
//           localStorage.removeItem('auth_token')
//           localStorage.removeItem('user')
//           return next({ name: 'SignIn' })
//         }
//       }
//     }
//   }

//   if (user && token && (to.name === 'AuthSignIn' || to.name === 'AuthSignUp')) {
//     if (user.role === 'admin') {
//       return next({ path: '/dashboard' })
//     } else if (user.role === 'user_client') {
//       return next({ path: '/' })
//     }
//   }

//   next()
// })

export default router
